import { gql } from '@apollo/client';

export const CORE_TOOL_ORDER_CATALOG_FIELDS = gql`
  fragment CoreToolOrderCatalogFields on ToolOrderCatalog {
    id
    quantity
    requesterComments
    requesterCommentsByUser {
      id
      firstName
      lastName
      roles {
        id
        name
      }
      employee {
        id
        imageUrl
        persona
      }
    }
    toolOrderId
    toolCatalogId
    nonCatalogDescription
    nonCatalogReferenceUrl
    nonCatalogSimilarToId
    nonCatalogUomId
    dispatcherComments
  }
`;
export const UPDATE_TOOL_ORDER_CATALOG = gql`
  mutation UpdateToolOrderCatalog($updateToolOrderCatalogInput: UpdateToolOrderCatalogInput!) {
    updateToolOrderCatalog(updateToolOrderCatalogInput: $updateToolOrderCatalogInput) {
      toolOrderCatalog {
        id
        quantity
        requesterComments
        nonCatalogDescription
        nonCatalogReferenceUrl
        nonCatalogUomId
        dispatcherComments
      }
      errors
    }
  }
`;
